
import {Component, Vue} from 'vue-property-decorator';
import {integrityApi} from "@/api/integrity";
import {IPage} from "@/js/page"
import vuePrototype from "@/common/prototype";
import baseUrl, {imageUrl} from "@/constants";
import echarts from "echarts";
import {onMounted} from "vue";
import QijuTianXieZhiNan from "@/components/QiJuTianXieZhiNan.vue";
import ckeditor from "@/components/AllCkeditorComponent.vue";
import {noticeApi} from "@/api/notice.ts";
@Component({
  name: "publictyDialog",
  components: {},
})
export default class Home extends Vue {
  baseUrl = baseUrl
  imageUrl = imageUrl
  publicityData = {
    data: {} as any,
    dialog: false
  }
  setData(row: any) {
    this.publicityData.data = row;
    this.publicityData.dialog = true;
  }
  downloadPdf(row: any) {
    window.open(baseUrl + "/file/download?file=" + row.promiseCreateUrl + "&name=" + row.orgName + "公示承诺书.pdf", '_blank');
  }
}
